import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'default',
    standalone: false
})
export class DefaultPipe implements PipeTransform {

  transform(value?: string, defaultVal?: string): unknown {
    if(value == null)
      return defaultVal;

    return value;
  }

}
